import styled from "styled-components";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useDispatch } from 'react-redux'
import { useState,useEffect} from "react";
import { consolaCuenta } from '../../../redux/actions/cuentasActions.js';
import api from '../../../axios.js'

const Container=styled.div`

`

export default function SelectConsolaCuenta(props){

	let { consolasId }=props;
	let [consolas,setConsolas]=useState([]);
	let dispatch=useDispatch();
	let [selectedIds, setSelectedIds] = useState([]);
	

	useEffect(()=>{		
			let reloadConsolas=async()=>{
				let rpta=await api('/consola');
				let data=rpta.data;
				
				let temp=[];
				if(consolasId){
					consolasId.forEach(ele=>{
						let co = data.find(consola=>consola.id==ele);
						if(co){temp.push(co)}
					});
					setConsolas(temp);	
				}
							
			};			
			reloadConsolas();
	},[consolasId]);


let handleChange=(event)=>{

 const id = event.target.id;
  const isChecked = event.target.checked;

  setSelectedIds(prev => {
    const updated = isChecked
      ? [...prev, id]
      : prev.filter(i => i !== id);

    dispatch(consolaCuenta({ Consolas: updated }));
    return updated;
  });

}

	return(
		<Container>			
      			{consolas?
      				consolas.map(consola=><FormControlLabel key={consola.id} control={<Checkbox id={consola.descripcion} name={consola.descripcion} onChange={handleChange} />} label={consola.descripcion}  />):null}
      			
    	</Container>

		)
}